import type { DriveStep } from 'driver.js';

export const doctorPreScreeningSteps: DriveStep[] = [
  {
    element: '[data-tour="doctor-prescreening-header"]',
    popover: {
      title: 'Incoming Attorney Requests',
      description: 'All pre-screening requests submitted through your intake form appear here.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-prescreening-search"]',
    popover: {
      title: 'Search and Filter',
      description:
        'Find requests by name, firm, or status. Filter by pending, accepted, or rejected.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-prescreening-table"]',
    popover: {
      title: 'Request List',
      description:
        'Click any request to review details, then accept to create a case or reject with a note. A conflict check runs automatically.',
      side: 'top',
      align: 'center',
    },
  },
];
